import {CoreMenu} from '@core/types';

export const menu: CoreMenu[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'MENU.DASHBOARD',
        type: 'item',
        icon: 'fas fa-sign',
        url: 'dashboard',
        availableTo: ['STOCKIST']
    },
    {
        id: 'products',
        title: 'Products',
        translate: 'MENU.PRODUCTS',
        type: 'item',
        icon: 'fa fa-shopping-cart',
        url: 'products',
        availableTo: ['STOCKIST']
    },
    {
        id: 'packages',
        title: 'Packages',
        translate: 'MENU.PACKAGES',
        type: 'item',
        icon: 'fa fa-shopping-bag',
        url: 'packages',
        availableTo: ['STOCKIST']
    },
    {
        id: 'stocks',
        title: 'Stocks',
        translate: 'MENU.STOCKS.COLLAPSIBLE',
        type: 'collapsible',
        availableTo: ['STOCKIST'],
        icon: 'box',
        children: [
            {
                id: 'product-orders',
                title: 'My Products',
                translate: 'MENU.STOCKS.MY_PRODUCTS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'my-products'
            },
            {
                id: 'my-orders',
                title: 'My Orders',
                translate: 'MENU.STOCKS.MY_ORDERS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'my-orders'
            }
        ],
    },
    {
        id: 'users',
        title: 'Users',
        translate: 'MENU.USERS.COLLAPSIBLE',
        type: 'collapsible',
        availableTo: ['STOCKIST'],
        icon: 'users',
        children: [
            {
                id: 'product-orders',
                title: 'Product Orders',
                translate: 'MENU.USERS.PRODUCT_ORDERS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'product-orders'
            },
            {
                id: 'package-orders',
                title: 'Package Orders',
                translate: 'MENU.USERS.PACKAGE_ORDERS',
                type: 'item',
                icon: 'fa fa-circle-o',
                url: 'package-orders'
            }
        ],
    },
    {
        id: 'support-tickets',
        title: 'Support Tickets',
        translate: 'MENU.SUPPORT_TICKETS',
        type: 'item',
        icon: 'fa fa-question-circle',
        url: 'support-tickets',
        availableTo: ['STOCKIST']
    },
    {
        id: 'sales-income',
        title: 'Sales Income',
        translate: 'MENU.SALES_INCOME',
        type: 'item',
        icon: 'fa fa-credit-card',
        url: 'sales-income',
        availableTo: ['STOCKIST']
    }
];
